/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
	// ---------------------------- 1 -----------------------------------------------
	{
		id: "EGLXOVhxLco",
		title: "Doodle for Beginners | Draw step by step With Me",
		channel: "Artisty",
		category: "Doodle",
		uploadedOn: "2 Years ago",
		thumbnail:
			"https://i.ytimg.com/vi/EGLXOVhxLco/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBwIHbKYPuFIWwsFvTiCawjRGIKRA",
		views: "11K",
		likes: "1K",
		subscription: "55K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSZFMqBNWHRbePrfgDoUz-DSCsQTnyX_vhlNoRPPA=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Don’t know what to draw? Don’t know how to draw? No worries! In this video I’ll share 50 cute and easy doodles to fill your sketchbook. If you’re bored at school, if you’re a beginner at drawing, I’ll show you step by step how to make every doodle you’ll ever need!",
	},
	// ---------------------------- 2 -----------------------------------------------
	{
		id: "BCBr7Fg6UCU",
		title: "Doodle art | How to Doodle ",
		channel: "Vinnie's Doodle World",
		category: "Doodle",
		uploadedOn: "1 Years ago",
		thumbnail:
			"https://i.ytimg.com/vi/BCBr7Fg6UCU/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAtANe69EWgtuYla2yWPBzbJT3tEA",
		views: "6K",
		likes: "1.4K",
		subscription: "54K",
		channelAvatar:
			"https://yt3.ggpht.com/ccyiYA12uMCkQfndLE4kOxptvwe405Cm4Sdwx9yv9vx4oVMKMCQmL0kyayTJjAkCMZBeq7KsgIE=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Don’t know what to draw? Don’t know how to draw? No worries! In this video I’ll share 50 cute and easy doodles to fill your sketchbook. If you’re bored at school, if you’re a beginner at drawing, I’ll show you step by step how to make every doodle you’ll ever need!",
	},
	// ---------------------------- 3 -----------------------------------------------
	{
		id: "F79ZaTL_vA0",
		title: "Doodle for Beginners | Draw step by step With Me",
		channel: "Artisty",
		category: "Doodle",
		uploadedOn: "2 Years ago",
		thumbnail:
			"https://i.ytimg.com/vi/F79ZaTL_vA0/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD5gBDJ0MOSWANEolsVMXdHKvwxBA",
		views: "11K",
		likes: "1K",
		subscription: "55K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSZFMqBNWHRbePrfgDoUz-DSCsQTnyX_vhlNoRPPA=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Don’t know what to draw? Don’t know how to draw? No worries! In this video I’ll share 50 cute and easy doodles to fill your sketchbook. If you’re bored at school, if you’re a beginner at drawing, I’ll show you step by step how to make every doodle you’ll ever need!",
	},
	// ---------------------------- 4 -----------------------------------------------
	{
		id: "ztRD2mu0nqQ",
		title: "Doodle for Beginners | Draw step by step With Me",
		channel: "Artisty",
		category: "Doodle",
		uploadedOn: "2 Years ago",
		thumbnail:
			"https://i.ytimg.com/vi/ztRD2mu0nqQ/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDc-Tsbyp8WUuzr80RZE_6dQv6idQ",
		views: "11K",
		likes: "1K",
		subscription: "55K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSZFMqBNWHRbePrfgDoUz-DSCsQTnyX_vhlNoRPPA=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Don’t know what to draw? Don’t know how to draw? No worries! In this video I’ll share 50 cute and easy doodles to fill your sketchbook. If you’re bored at school, if you’re a beginner at drawing, I’ll show you step by step how to make every doodle you’ll ever need!",
	},
	// ---------------------------- 5 -----------------------------------------------
	{
		id: "2-OrSA6kaLM",
		title: "Doodle for Beginners | Draw step by step With Me",
		channel: "Artisty",
		category: "Doodle",
		uploadedOn: "2 Years ago",
		thumbnail:
			"https://i.ytimg.com/vi/2-OrSA6kaLM/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBBmwQNSGcNFoGzn2QDOPVxpx0oqg",
		views: "11K",
		likes: "1K",
		subscription: "55K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSZFMqBNWHRbePrfgDoUz-DSCsQTnyX_vhlNoRPPA=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Don’t know what to draw? Don’t know how to draw? No worries! In this video I’ll share 50 cute and easy doodles to fill your sketchbook. If you’re bored at school, if you’re a beginner at drawing, I’ll show you step by step how to make every doodle you’ll ever need!",
	},
	// ---------------------------- 6 -----------------------------------------------
	{
		id: "Qv_MGHzMFyI",
		title: "Doodle for Beginners | Draw step by step With Me",
		channel: "Artisty",
		category: "Doodle",
		uploadedOn: "2 Years ago",
		thumbnail:
			"https://i.ytimg.com/vi/Qv_MGHzMFyI/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAKCPfFvZaKY8PXxK1tpSEuPGwDWA",
		views: "11K",
		likes: "1K",
		subscription: "55K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSZFMqBNWHRbePrfgDoUz-DSCsQTnyX_vhlNoRPPA=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Don’t know what to draw? Don’t know how to draw? No worries! In this video I’ll share 50 cute and easy doodles to fill your sketchbook. If you’re bored at school, if you’re a beginner at drawing, I’ll show you step by step how to make every doodle you’ll ever need!",
	},
	// ---------------------------- 7 -----------------------------------------------
	{
		id: "W2HDsQGHWQk",
		title: "Doodle for Beginners | Draw step by step With Me",
		channel: "Artisty",
		category: "Doodle",
		uploadedOn: "2 Years ago",
		thumbnail:
			"https://i.ytimg.com/vi/W2HDsQGHWQk/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAxJM7L9ILaEKnF6tkoKVt4vFTORA",
		views: "11K",
		likes: "1K",
		subscription: "55K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSZFMqBNWHRbePrfgDoUz-DSCsQTnyX_vhlNoRPPA=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Don’t know what to draw? Don’t know how to draw? No worries! In this video I’ll share 50 cute and easy doodles to fill your sketchbook. If you’re bored at school, if you’re a beginner at drawing, I’ll show you step by step how to make every doodle you’ll ever need!",
	},

	// ================== FIGMA =======================================================
	// ---------------------------- 8 -----------------------------------------------
	{
		id: "Cx2dkpBxst8",
		title: "What's Figma?",
		channel: "Figma",
		category: "Figma",
		uploadedOn: "2 Years ago",
		thumbnail:
			"https://i.ytimg.com/vi/Cx2dkpBxst8/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAg1mOo0z0bvAzouYKle472SbRjsQ",
		views: "602K",
		likes: "5.3K",
		subscription: "230K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLRrH_wT7RwStCNum43bUnEavYBJNISAWhmMJgJWOg=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Figma is where teams design together. Bring ideas to life in a design, wireframe, or prototype. Partner with teammates from content creation to design implementation. Get better feedback from your stakeholders. Figma gets everyone on the same page—literally.",
	},
	// ---------------------------- 9 -----------------------------------------------
	{
		id: "eZJOSK4gXl4",
		title: "Getting started with Figma: A beginner's guide",
		channel: "Kevin Powell",
		category: "Figma",
		uploadedOn: "1 Year ago",
		thumbnail:
			"https://i.ytimg.com/vi/eZJOSK4gXl4/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD7ORVVB1Osp5TnvM3xHDn1INS_FQ",
		views: "131K",
		likes: "4.3K",
		subscription: "515K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLT1tLx7BgAa7_SHaXE0hDRjQu1BRihsEDZ3lmUUcg=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Figma is a really amazing design and prototyping tool that has exploded in popularity. If you are thinking about making the switch to it, or if you're looking to figure out how to use it, this tutorial is for you!",
	},
	// ---------------------------- 10 -----------------------------------------------
	{
		id: "Gu1so3pz4bA",
		title: "The Figma 2021 Crash Course by Example",
		channel: "DesignCourse",
		category: "Figma",
		uploadedOn: "1 Year ago",
		thumbnail:
			"https://i.ytimg.com/vi/Gu1so3pz4bA/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDNjFQmSN7OcRQwta0sZ9L2r_ZDhQ",
		views: "550K",
		likes: "15K",
		subscription: "914K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLQ2BILkH6zZdQLVMwiUtY9ejAOHBiTOnlANQ-jSZA=s88-c-k-c0x00ffffff-no-rj",
		description:
			"-- Today, we're going to step into the world of UI/UX design and cover Figma here in 2021. Figma is a UI/UX design and prototyping tool. In this crash course, I'm going to show you how to use Figma to design a website with multiple pages, interactions and animations. ",
	},
	// ================== UI/UX =======================================================
	// ---------------------------- 11 -----------------------------------------------
	{
		id: "It2ON3hAPl0",
		title:
			"Ultimate Guide For Self Taught UX/UI Designers! | Design Weekly by Punit Chawla",
		channel: "Punit Chawla",
		category: "UI/UX",
		uploadedOn: "10 Months ago",
		thumbnail:
			"https://i.ytimg.com/vi/It2ON3hAPl0/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAhbm0zAs6uAZsWyEICrYbIoozAJg",
		views: "32K",
		likes: "2.2K",
		subscription: "98.6K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLSMqaNfFdvhFFsrTQXUvZ2T4cl-Eo2J0vF8TmashGE=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Being a self taught UX/UI designer is very difficult. There are a lot of obstacles, challenges, and confusion. Today I'll be telling you how you can plan, practice and create a beautiful design portfolio for free! ",
	},
	// ---------------------------- 12 -----------------------------------------------
	{
		id: "YiLUYf4HDh4",
		title: "Learn UI/UX Design & Figma - 2022 Interactive Crash Course",
		channel: "DesignCourse",
		category: "UI/UX",
		uploadedOn: "3 Months ago",
		thumbnail:
			"https://i.ytimg.com/vi/YiLUYf4HDh4/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAJwWv8Ao0xMlrCabIaYXKgItGlCQ",
		views: "110K",
		likes: "4K",
		subscription: "914K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLQ2BILkH6zZdQLVMwiUtY9ejAOHBiTOnlANQ-jSZA=s88-c-k-c0x00ffffff-no-rj",
		description:
			"-- Today, we're going to focus on creating a website UI solely within Figma and using most of its features. We're going to start out with an interactive portion of the video where you're challenged with my new uEye game, which helps you learn UI design fundamentals. ",
	},
	// ================== ADOBE XD =======================================================
	// ---------------------------- 13 -----------------------------------------------
	{
		id: "TfdrHObZ8zY",
		title: "What Is Adobe XD?",
		channel: "Envato Tuts+",
		category: "Adobe XD",
		uploadedOn: "1 Year ago",
		thumbnail:
			"https://i.ytimg.com/vi/TfdrHObZ8zY/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDfMbulcUUb3lQhwtM9Jo-OvHD43w",
		views: "95K",
		likes: "1.7K",
		subscription: "817K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLRIAiurLyKTSocqKXruHqnTxLiso4qIHxKchA9OKQ=s88-c-k-c0x00ffffff-no-rj",
		description:
			"Adobe XD is a vector-based UI and UX design tool that you can use to design anything from smartwatch apps to fully fledged websites. Let’s look at what it offers web designers and why it's so popular.",
	},
	// ---------------------------- 14 -----------------------------------------------
	{
		id: "oo5EoelQ_DQ",
		title: "Adobe XD 2022 Crash Course - Design a Real Layout!",
		channel: "DesignCourse",
		category: "Adobe XD",
		uploadedOn: "2 Months ago",
		thumbnail:
			"https://i.ytimg.com/vi/oo5EoelQ_DQ/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCaguvmF4ayYYWfBxSMSwqZ2fCJvg",
		views: "26K",
		likes: "992",
		subscription: "914K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLQ2BILkH6zZdQLVMwiUtY9ejAOHBiTOnlANQ-jSZA=s88-c-k-c0x00ffffff-no-rj",
		description:
			"-- Today, you're going to step into the world of Adobe Experience Design (Adobe XD) to design and prototype a website for a fictional business.",
	},
	// ---------------------------- 15 -----------------------------------------------
	{
		id: "c-6AaS7997w",
		title: "E-commerce App Design in Adobe XD (Wireframe/Mockup + Prototype)",
		channel: "DesignSense",
		category: "Adobe XD",
		uploadedOn: "1 year ago",
		thumbnail:
			"https://i.ytimg.com/vi/c-6AaS7997w/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCqe-sX4fpUnVv8GLbJyzEFF3Btug",
		views: "446K",
		likes: "13K",
		subscription: "210K",
		channelAvatar:
			"https://yt3.ggpht.com/ytc/AKedOLQ2BILkH6zZdQLVMwiUtY9ejAOHBiTOnlANQ-jSZA=s88-c-k-c0x00ffffff-no-rj",
		description: `Hi guys!
Today we will learn to design an eCommerce app in Adobe XD.

Steps:
1. High fidelity wireframe/Mockup
2. Prototyping`,
	},
];
